const timer = (isWait, callback, delay, ...args) => {
    const id = isWait ? setTimeout(callback, delay, ...args) : setInterval(callback, delay, ...args);
    return {
        id,
        clear: () => (isWait ? clearTimeout(id) : clearInterval(id)),
    };
};
export const timeDelay = (delay) => new Promise(resolve => setTimeout(resolve, delay));
export const timeWait = (callback, delay, ...args) => timer(true, callback, delay, ...args);
export const timeLoop = (callback, delay, ...args) => timer(false, callback, delay, ...args);
//# sourceMappingURL=time.js.map